import React from 'react';
import ClassAssembly  from 'views/ClassAssembly1B';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;